const fromStatusToMessageV3 = (status) =>
  Number.isSafeInteger(status) ? `Unknown error with code ${status}` : 'Unknown error';

// noinspection JSUnusedGlobalSymbols
export default fromStatusToMessageV3;
